import PostsSerializer from './base';

export default class Reaction extends PostsSerializer {}
